import request from '../utils/request'

/**
 * 公共相关接口
 */

// 获取微信配置
export function getWxConfig(params) {
  return request({
    url: '/h5/wx/config',
    method: 'get',
    params
  })
}

// 微信登录
export function wxLogin(data) {
  return request({
    url: '/h5/wx/login',
    method: 'post',
    data
  })
}

// 获取直播状态
export function getLiveStatus() {
  return request({
    url: '/h5/live/status',
    method: 'get'
  })
}

// 获取群聊菜单显示状态
export function getChatMenuStatus() {
  return request({
    url: '/h5/live/chatmenu',
    method: 'get'
  })
}

// 图片上传
export function uploadImage(data) {
  return request({
    url: '/h5/upload/image',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 提交反馈
export function submitFeedback(data) {
  return request({
    url: '/h5/common/feedback',
    method: 'post',
    data
  })
}

// 我的反馈列表
export function getFeedbackList() {
  return request({
    url: '/h5/common/feedback/list',
    method: 'get'
  })
}

// 提交投诉
export function submitComplaint(data) {
  return request({
    url: '/h5/common/complaint',
    method: 'post',
    data
  })
}

// 我的投诉列表
export function getComplaintList() {
  return request({
    url: '/h5/common/complaint/list',
    method: 'get'
  })
}
